"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var core_2 = require("@ngx-translate/core");
var lodash_1 = require("lodash");
var logger_service_1 = require("./logger.service");
var common_1 = require("@angular/common");
var nl_1 = require("@angular/common/locales/nl");
var en_1 = require("@angular/common/locales/en");
var es_1 = require("@angular/common/locales/es");
var it_1 = require("@angular/common/locales/it");
var moment = require("moment");
var enUK = require('../../translations/en-UK.json');
var esES = require('../../translations/es-ES.json');
var itIT = require('../../translations/it-IT.json');
var nlNL = require('../../translations/nl-NL.json');
var log = new logger_service_1.Logger('I18nService');
var languageKey = 'language';
/**
 * Pass-through function to mark a string for translation extraction.
 * Running `npm translations:extract` will include the given string by using this.
 * @param {string} s The string to extract for translation.
 * @return {string} The same string.
 */
function extract(s) {
    return s;
}
exports.extract = extract;
var I18nService = /** @class */ (function () {
    function I18nService(translateService) {
        this.translateService = translateService;
        this.supportedLanguages = [];
        common_1.registerLocaleData(nl_1.default, 'nl-NL');
        common_1.registerLocaleData(en_1.default, 'en-UK');
        common_1.registerLocaleData(es_1.default, 'es-ES');
        common_1.registerLocaleData(it_1.default, 'it-IT');
        // Embed languages to avoid extra HTTP requests
        translateService.setTranslation('en-UK', enUK);
        translateService.setTranslation('nl-NL', nlNL);
        translateService.setTranslation('es-ES', esES);
        translateService.setTranslation('it-IT', itIT);
    }
    Object.defineProperty(I18nService.prototype, "language", {
        /**
         * Gets the current language.
         * @return {string} The current language code.
         */
        get: function () {
            return this.translateService.currentLang;
        },
        /**
         * Sets the current language.
         * Note: The current language is saved to the local storage.
         * If no parameter is specified, the language is loaded from local storage (if present).
         * @param {string} language The IETF language code to set.
         */
        set: function (language) {
            language = language || localStorage.getItem(languageKey) || this.translateService.getBrowserCultureLang();
            var isSupportedLanguage = lodash_1.includes(this.supportedLanguages.map(function (lang) { return lang.code; }), language);
            // If no exact match is found, search without the region
            if (language && !isSupportedLanguage) {
                language = language.split('-')[0];
                var supportedLanguageWithoutRegion = this.supportedLanguages.find(function (s) { return s.code.startsWith(language); });
                language = supportedLanguageWithoutRegion ? supportedLanguageWithoutRegion.code || '' : '';
                isSupportedLanguage = Boolean(language);
            }
            // Fallback if language is not supported
            if (!isSupportedLanguage) {
                language = this.defaultLanguage;
            }
            moment.locale(language);
            log.debug("Language set to " + language);
            this.translateService.use(language);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Initializes i18n for the application.
     * Loads language from local storage if present, or sets default language.
     * @param {!string} defaultLanguage The default language to use.
     * @param {Array.<String>} supportedLanguages The list of supported languages.
     */
    I18nService.prototype.init = function (defaultLanguage, supportedLanguages) {
        this.defaultLanguage = defaultLanguage;
        this.supportedLanguages = supportedLanguages;
        this.language = '';
        this.translateService.onLangChange
            .subscribe(function (event) {
            moment.locale(event.lang);
            localStorage.setItem(languageKey, event.lang);
        });
    };
    I18nService = tslib_1.__decorate([
        core_1.Injectable(),
        tslib_1.__metadata("design:paramtypes", [core_2.TranslateService])
    ], I18nService);
    return I18nService;
}());
exports.I18nService = I18nService;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/core/i18n.service.ts
// module id = 61
// module chunks = 0